import { useSnackbar } from "notistack";
import React, { useCallback, useEffect, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import { fullScreenLoadingSlice } from "../../../../../data/redux/slice/loaderSlice";
import { fetchAllApprovalList } from "../../../../../services/fetchListingData";
import { setCommentsHeader } from "../../../../../services/getCommentsWithTab";
import secureStorage from "../../../../../services/secureStorage";
import { CommentIcon } from "../../../../../utility/constants/assetsManager";
import {
  colorDarkGreen,
  colorDarkRed,
  colorLightGreen,
  colorLightRed,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import {
  SS_AUTH_TOKEN,
  SS_ROLE,
} from "../../../../../utility/constants/secureStorageManager";

import {
  APPROVAL_LIST,
  CLIENT_EDIT_ACL,
  DASHBOARD_APPROVAL_ACL,
  STATUS_CODE_200,
  PAYIN_SERVICE,
  PAYOUT_SERVICE,
  ACTIVE,
  RNC,
  RNCAPPROVED,
  ADMIN,
  ADMIN_USER,
  APPROVE,
  RNCREJECTED,
  REJECT,
  REJECTED,
  PENDING,
  RNCPENDING,
  APPROVED,
  RNC_APPROVE_ACTION,
  RNCREJECT,
  SALES,
  VAN_SERVICE,
  VAN_UPI,
} from "../../../../../utility/constants/valueConstants";
import {
  validateEmail,
  validatePan,
} from "../../../../../utility/emailValidator";

import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import AlertModals from "../../../../components/ui_comps/AlertModals";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import { formDataPush } from "../../clients/client_onboard/ResellerDetails";
import BankDetails from "./BankDetails";
import BasicDetails from "./BasicDetails";
import BusinessDetails from "./BusinessDetails";
import CommentModalBody from "./CommentModalBody";
import Documents from "./Documents";
import ServiceType from "./ServiceType";
import TransactionLimit from "./TransactionLimit";
import Vkyc from "./Vkyc";

const ConfirmationModal = ({ onClose }) => {
  const navigate = useNavigate();

  return (
    <>
      <div
        style={{
          color: primaryColor,
          fontWeight: "500",
          textAlign: "center",
          marginBottom: 20,
          alignItems: "center",
        }}
      >
        Client Rejected
      </div>
      <p style={{ textAlign: "center", color: "#6C6B6B", margin: 30 }}>
        Client has been rejected we will notify the onboarded person about it{" "}
      </p>
      <div style={{ width: "fit-content", margin: "auto" }}>
        <CustomButton
          title={"Ok"}
          onClick={() => {
            onClose();
            navigate("/approval/list");
          }}
        />
      </div>
    </>
  );
};

const ActionComponent = ({
  onClickEdit,
  isEditClicked,
  onClickSave,
  aclData,
}) => {
  const role = secureStorage.getItem(SS_ROLE);
  return (
    <div style={{ display: "flex" }}>
      {role === SALES && (
        <>
          <CustomButton
            ionDirection="left"
            icon={
              isEditClicked ? null : <BiEditAlt size={16} color="#38369C" />
            }
            styles={{
              backgroundColor: isEditClicked
                ? "transparent"
                : "rgba(111, 108, 255, 0.1)",
              border: isEditClicked ? "1px solid #1E2234" : "0px solid #38369C",
              marginLeft: "10px",
            }}
            title={isEditClicked ? "Cancel" : "Edit"}
            textStyles={{ color: isEditClicked ? "#1E2234" : "#38369C" }}
            onClick={onClickEdit}
          />
        </>
      )}

      {isEditClicked && (
        <CustomButton
          ionDirection="left"
          icon={<BiEditAlt size={16} color="#38369C" />}
          styles={{
            background: "rgba(111, 108, 255, 0.1)",
            border: "1px solid #38369C",
            marginLeft: "10px",
          }}
          title={"Save"}
          textStyles={{ color: "#38369C" }}
          onClick={onClickSave}
        />
      )}
    </div>
  );
};

function RncValidator() {
  const [currentTab, setCurrentTab] = useState(0);
  const [clientDetails, setClientDetails] = useState({});
  const [clientDocs, setClientDocs] = useState({});
  const [isEditClicked, setIsEditClicked] = useState(false);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [loading, setLoading] = useState(false);
  const [onClickViewMore, setOnClickViewMore] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [clientData, setClientData] = useState();
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [payin, setPayin] = useState({});
  const [payout, setPayout] = useState({});
  const [van, setVan] = useState({});
  const approvalData = useSelector((state) => state.listingSlice.approvalList);
  const [vanUpi, setVanUpi] = useState({});
  const location = useLocation();
  const role = secureStorage.getItem(SS_ROLE);
  const [tab, setTab] = useState([]);
  const [commentTabs, setCommentTabs] = useState([]);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [service, setService] = useState([
    {
      serviceProviderName: "",
      serviceProviderType: "",
      neokredRate: "",
      resellerRate: "",
      comissionType: "",
      program_id: clientData?.programs[0]?.program_id,
      comissionRate: [
        {
          from: "",
          to: "",
          value: "",
          type: "",
        },
      ],
      notifyUrl: "",
    },
  ]);
  const [ipWhitelist, setIpwhitelist] = useState("");

  const styles = {
    rejectedStyles: {
      background: colorLightRed,
      color: colorDarkRed,
      borderRadius: "4px",
      fontSize: "14px",
      width: "100px",
      height: 40,
      justifyContent: "center",
      padding: "6px 8px",
      alignItems: "center",
      display: "flex",
      maxWidth: "110px",
    },

    approvedStyles: {
      background: colorLightGreen,
      color: colorDarkGreen,
      borderRadius: "4px",
      fontSize: "14px",
      width: "100px",
      height: 40,
      justifyContent: "center",
      padding: "6px 8px",
      alignItems: "center",
      display: "flex",
      maxWidth: "110px",
    },
  };

  let tabs = [
    { name: "Basic Details", key: 0 },
    { name: "Business Details", key: 1 },
    { name: "Bank Details", key: 2 },
    { name: "Documents", key: 3 },
    { name: "Service Type", key: 5 },
    { name: "Transaction Limit", key: 6 },
  ];

  const onClickApproveReject = (clientId, approval_status, reason = "") => {
    setLoading(true);
    dispatch(fullScreenLoadingSlice(true));

    let status = "";

    if (
      aclData.includes(RNC_APPROVE_ACTION) &&
      location.state.status === RNCPENDING
    ) {
      if (approval_status === APPROVE) {
        status = RNCAPPROVED;
      } else {
        status = RNCREJECTED;
      }
    } else if (
      // aclData.includes(RNC_APPROVE_ACTION) &&
      location.state.status === PENDING
    ) {
      status = approval_status;
    }

    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status,
      reason,
    })

      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          navigate("/approval/list");
          enqueueSnackbar(response.message, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      })
      .finally(() => {
        dispatch(fullScreenLoadingSlice(false));
        setLoading(false);
        setLoading(false);
      });
  };

  const handleTabChange = useCallback((tab) => {
    setCurrentTab(tab);
  }, []);

  const onClickEditDocs = () => {
    let isKycVeifiedStatus = clientData.isKycVerified;

    if (isKycVeifiedStatus === false && clientDocs.isKycVerified === true) {
      if (clientDocs.videoKycUrl === "") {
        enqueueSnackbar("Please upload video", {
          variant: "error",
        });
        return;
      }
    }

    dispatch(fullScreenLoadingSlice(true));
    const formdata = formDataPush({
      ...clientDocs,
      userId: clientData?.userId,
    });
    const token = secureStorage.getItem(SS_AUTH_TOKEN);
    fetch(API_ENDPOINT.core_url + "client/update/docs", {
      body: formdata,
      headers: {
        Authorization: "Bearer " + token,
        isimageurl: true,
      },
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/approval/list");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };

  const onClickEditClient = () => {
    if (
      clientDetails?.mobileNumber &&
      clientDetails?.mobileNumber.length < 10
    ) {
      enqueueSnackbar("Invalid Mobile Number", {
        variant: "error",
      });
      return;
    }

    if (clientDetails?.email && !validateEmail(clientDetails?.email)) {
      enqueueSnackbar("Invalid email id", {
        variant: "error",
      });
      return;
    }
    if (clientDetails?.PanNumber && clientDetails?.PanNumber.length < 10) {
      enqueueSnackbar("Invalid PAN Number", {
        variant: "error",
      });
      return;
    }
    if (clientDetails?.gstNumber && clientDetails?.gstNumber.length < 15) {
      enqueueSnackbar("Invalid GST Number", {
        variant: "error",
      });
      return;
    }
    if (
      clientDetails?.remitterAccountNumber &&
      clientDetails?.remitterAccountNumber.length < 9
    ) {
      enqueueSnackbar("Invalid account Number", {
        variant: "error",
      });
      return;
    }

    if (
      clientDetails?.bankAccountNumber &&
      clientDetails?.bankAccountNumber.length < 9
    ) {
      enqueueSnackbar("Invalid account Number", {
        variant: "error",
      });
      return;
    }

    if (
      clientDetails?.bankIfscCode &&
      clientDetails?.bankIfscCode.length != 11
    ) {
      enqueueSnackbar("Invalid ifsc code", {
        variant: "error",
      });
      return;
    }

    if (
      clientDetails?.remitterIfscCode &&
      clientDetails?.remitterIfscCode.length != 11
    ) {
      enqueueSnackbar("Invalid ifsc code", {
        variant: "error",
      });
      return;
    }

    ApiRequestPost.editClientUser({
      email: clientDetails?.email,
      firstName: clientDetails?.firstName,
      lastName: clientDetails?.lastName,
      mobileNumber: clientDetails?.mobileNumber,
      userId: clientData?.userId,
      userRefId: clientData?.userRefId,
      accountHolderName: clientDetails?.nameAsPerBank,
      accountNumber: clientDetails?.bankAccountNumber,
      ifscCode: clientDetails?.bankIfscCode,
      dateOfBirth: clientDetails?.dateOfBirth,
      panNumber: clientDetails?.PanNumber,
      gstNumber: clientDetails?.gstNumber,
      businessType: clientDetails?.businessType,
      websiteLink: clientDetails?.webLink,
      businessName: clientDetails?.businessName,
      businessAddress: clientDetails?.businessAddress,
      accountHolderName: clientDetails?.nameAsPerBank,
      isKycVerified: clientDetails?.isKycVerified,
      remitterAccountName: clientDetails?.remitterNameAsPerBank,
      remitterAccountNumber: clientDetails?.remitterAccountNumber,
      remitterAccountIfsc: clientDetails?.remitterIfscCode,
      dinNumber: clientDetails?.dinNumber,
      dpan: clientDetails?.dpan,
      industryType: clientDetails?.industryType,
      legalName: clientDetails?.legalName,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/approval/list");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  const updateRate = () => {
    if (service[0]?.neokredRate[service[0]?.neokredRate?.length - 1] === ".") {
      enqueueSnackbar("Please enter valid Neokred rate", {
        variant: "error",
      });
      return;
    }
    if (
      service[0]?.resellerRate[service[0]?.resellerRate?.length - 1] === "."
    ) {
      enqueueSnackbar("Please enter valid reseller rate", {
        variant: "error",
      });
      return;
    }
    if (
      service[0]?.comissionRate[0]?.value[
        service[0]?.comissionRate[0]?.value?.length - 1
      ] === "."
    ) {
      enqueueSnackbar("Please enter valid client rate", {
        variant: "error",
      });
      return;
    }
    if (service[1]?.neokredRate[service[1]?.neokredRate?.length - 1] === ".") {
      enqueueSnackbar("Please enter valid Neokred rate", {
        variant: "error",
      });
      return;
    }
    if (
      service[1]?.resellerRate[service[1]?.resellerRate?.length - 1] === "."
    ) {
      enqueueSnackbar("Please enter valid reseller rate", {
        variant: "error",
      });
      return;
    }
    if (
      service[1]?.comissionRate[0]?.value[
        service[1]?.comissionRate[0]?.value?.length - 1
      ] === "."
    ) {
      enqueueSnackbar("Please enter valid client rate", {
        variant: "error",
      });
      return;
    }

    let index = 0;
    let obj = service[index];
    let svcName = service[index].serviceProviderName;

    const matchingPrograms = clientData?.programs?.find(
      (e) => e.serviceProviderName === svcName?.toUpperCase()
    );
    obj.program_id = matchingPrograms.program_id;

    ApiRequestPost.updateRate({
      clientId: clientData?.userId,
      service: service,
      ipWhitelist: ipWhitelist,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          navigate("/approval/list");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const insert = (arr, index, newItem) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted item
    newItem,
    // part of the array after the specified index
    ...arr.slice(index),
  ];

  useEffect(() => {
    // Checking VKYC for payin service
    if (payin) {
      setTab(insert(tabs, 4, { name: "VKYC", key: 4 }));
    } else setTab(tabs);
  }, [payin]);

  useEffect(() => {
    setIsEditClicked(false);
    setClientDetails("");
  }, [currentTab]);

  useEffect(() => {
    setClientData(location.state.clientData);
    setPayout(
      location?.state?.clientData?.service.find(
        (e) => e?.serviceType === PAYOUT_SERVICE
      )
    );
    setPayin(
      location?.state?.clientData?.service.find(
        (e) => e?.serviceType === PAYIN_SERVICE
      )
    );
    setVan(
      location?.state?.clientData?.service.find(
        (e) => e?.serviceType === VAN_SERVICE
      )
    );
    setVanUpi(
      location?.state?.clientData?.service.find(
        (e) => e?.serviceType === VAN_UPI
      )
    );
  }, [location]);

  useEffect(() => {
    let d = setCommentsHeader(currentTab, clientData);
    setCommentTabs(d);
  }, [currentTab, clientData]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        headerTitle="Approval"
        filterRequired={false}
      />
      <div style={{ padding: "2%", background: "#F3F3F3" }}>
        <div
          style={{
            width: "100%",

            padding: 20,
            background: "#FFFFFF",
            display: "flex",
            justifyContent: "space-between",
            gap: "10",
          }}
        >
          <div>
            <p style={{ color: "#7A7979", lineHeight: 1.5 }}>
              Client name:{" "}
              <span style={{ color: "#1E2234" }}>
                {clientData?.firstName} {clientData?.lastName}
              </span>{" "}
            </p>
            <p style={{ color: "#7A7979", lineHeight: 1.5 }}>
              {`Reseller Name: ${clientData?.resellerName}`}
            </p>
            <p style={{ color: "#7A7979", lineHeight: 1.5 }}>
              Business Name:
              <span style={{ color: "#1E2234" }}>
                {clientData?.businessName}
              </span>
            </p>
            <p style={{ color: "#7A7979", lineHeight: 1.5 }}>
              {clientData?.email}
            </p>
            <p style={{ color: "#7A7979", lineHeight: 1.5 }}>
              {`Onboarded By ${clientData?.createdBy.userName}`}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "start",
            }}
          >
            {payin && (
              <p style={{ color: "#6C6B6B" }}>
                Payin ({payin?.serviceProviderName})
              </p>
            )}
            {payout && (
              <p style={{ color: "#6C6B6B" }}>
                Payout ({payout?.serviceProviderName})
              </p>
            )}
            {van && (
              <p style={{ color: "#6C6B6B" }}>
                Van ({van?.serviceProviderName})
              </p>
            )}
            {vanUpi && (
              <p style={{ color: "#6C6B6B" }}>
                Upi Van ({vanUpi?.serviceProviderName})
              </p>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 5,
            }}
          >
            {(aclData.includes(APPROVAL_LIST) &&
              location.state.status === PENDING) ||
            (aclData.includes(APPROVAL_LIST) &&
              location.state.status === RNCPENDING) ? (
              <p>
                <CustomButton
                  title={"Comment"}
                  icon={<CommentIcon />}
                  ionDirection={"right"}
                  onClick={() => {
                    setOpenCommentModal(true);
                  }}
                />
              </p>
            ) : (
              ""
            )}
            {location.state.status === REJECTED ||
            location.state.status === RNCREJECTED ? (
              <p
                style={{
                  ...styles.rejectedStyles,
                }}
              >
                Rejected
              </p>
            ) : (aclData.includes(DASHBOARD_APPROVAL_ACL) &&
                location.state.status === PENDING) ||
              (aclData.includes(RNC_APPROVE_ACTION) &&
                location.state.status === RNCPENDING) ? (
              <p
                style={{
                  cursor: "pointer",
                  ...styles.rejectedStyles,
                }}
                // onClick={() => onViewMore(row)}
                onClick={() => {
                  setOnClickViewMore(true);
                  setClientData(clientData);
                }}
              >
                {"Reject"}
              </p>
            ) : (
              ""
            )}

            {location.state.status === APPROVED ||
            location.state.status === RNCAPPROVED ? (
              <p
                style={{
                  ...styles.approvedStyles,
                }}
              >
                Approved
              </p>
            ) : (aclData.includes(DASHBOARD_APPROVAL_ACL) &&
                location.state.status === PENDING) ||
              (aclData.includes(RNC_APPROVE_ACTION) &&
                location.state.status === RNCPENDING) ? (
              <p
                style={{
                  cursor: "pointer",
                  ...styles.approvedStyles,
                }}
                onClick={() => {
                  onClickApproveReject(clientData?.userId, APPROVE);
                }}
              >
                {"Approve"}
              </p>
            ) : (
              ""
            )}
          </div>
        </div>
        {(location.state.status === REJECTED ||
          location.state.status === RNCREJECTED) && (
          <div style={{ marginTop: 20 }}>
            <div style={{ color: "#69687D", marginBottom: 10 }}>
              {location.state.status === RNCREJECTED
                ? `Remark by ${clientData?.rncrejectedBy?.userName}`
                : location.state.status === REJECTED
                ? `Remark by ${clientData?.rejectedBy?.userName}`
                : ""}
            </div>

            <div
              style={{
                backgroundColor: "white",
                width: "60%",
                height: "100px",
                padding: 20,
                border: "1px solid #CCCEDB",
                minWidth: "600px",
              }}
            >
              {location.state.status === REJECTED
                ? clientData?.rejectedBy?.reason
                : clientData?.rncrejectedBy?.reason}
            </div>
          </div>
        )}
      </div>
      <CustomTabs
        tabs={tab}
        actionComponent={
          // aclData.includes(CLIENT_EDIT_ACL) &&
          currentTab !== 6 && clientData?.onBoardedStatus === RNCPENDING ? (
            <ActionComponent
              onClickEdit={() => {
                setIsEditClicked(!isEditClicked);
              }}
              isEditClicked={isEditClicked}
              onClickSave={() => {
                if (currentTab === 3 || currentTab === 4) {
                  if (Object.keys(clientDocs).length > 0) {
                    onClickEditDocs();
                  }
                } else if (Object.keys(clientDetails).length > 0) {
                  onClickEditClient();
                }
                if (currentTab === 5) {
                  updateRate();
                }
              }}
              aclData={aclData}
            />
          ) : null
        }
        backgroundrequired={false}
        activeIndex={currentTab}
        passCurrentTab={(data) => {
          handleTabChange(data);
        }}
      />
      {currentTab === 0 ? (
        <BasicDetails
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...clientDetails, ...val });
          }}
          status={location.state.status}
        />
      ) : currentTab === 1 ? (
        <BusinessDetails
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...clientDetails, ...val });
          }}
          status={location.state.status}
        />
      ) : currentTab === 2 ? (
        <BankDetails
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...clientDetails, ...val });
          }}
          status={location.state.status}
        />
      ) : currentTab === 3 ? (
        <Documents
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDocs({ ...val });
          }}
        />
      ) : currentTab === 4 ? (
        <Vkyc
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDocs({ ...val });
          }}
        />
      ) : currentTab === 5 ? (
        <>
          <ServiceType
            role={role}
            clientData={clientData}
            isEditClicked={isEditClicked}
            onChange={(val) => {
              setClientDocs({ ...val });
            }}
            status={location.state.status}
            onChangeFileds={(val) => {
              setService(val);
            }}
            onChangeIpwhiteList={(val) => {
              if (val.length > 0) {
                setIpwhitelist(val);
              }
            }}
          />
        </>
      ) : currentTab === 6 ? (
        <TransactionLimit
          role={role}
          clientData={clientData}
          isEditClicked={isEditClicked}
          onChange={() => {}}
        />
      ) : (
        ""
      )}
      {openCommentModal && (
        <CustomModal
          open={openCommentModal}
          onClose={() => {
            setOpenCommentModal(false);
          }}
          viewMoreStyle={{
            justifyContent: "flex-end",
          }}
          containerStyle={{
            height: "100%",
            borderRadius: "10px 0px 0px 10px",
            padding: "0px",
          }}
          isHeaderRequired={false}
        >
          <CommentModalBody
            data={clientData}
            tabs={setCommentsHeader(currentTab, clientData)}
            closeModal={() => {
              setOpenCommentModal(false);
            }}
          />
        </CustomModal>
      )}

      {onClickViewMore && (
        <CustomModal
          headerTitle=""
          open={onClickViewMore}
          onClose={() => {
            setOnClickViewMore(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          {confirm ? (
            <ConfirmationModal
              onClose={() => {
                setOnClickViewMore(false);
                setConfirm(false);
              }}
            />
          ) : (
            <AlertModals
              confirmButtonTitle={"Reject"}
              title={true}
              isConditional={false}
              onClickCancel={() => setOnClickViewMore(false)}
              onClickOk={(reason) => {
                if (reason) {
                  onClickApproveReject(clientData?.userId, REJECT, reason);
                } else {
                  enqueueSnackbar("Please enter reason for rejecting", {
                    variant: "error",
                  });
                }
              }}
              loading={loading}
              action={"reject"}
              reason={"reject"}
              data={clientData}
            />
          )}
        </CustomModal>
      )}
    </div>
  );
}

export default RncValidator;
